import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import { dataResources } from 'utils/constants';
import styles from './codiespectador.module.scss';

const { basePath } = dataResources;

export default function CodiEspectador(props) {
    const { codiAD, codiSub, codiVO, estil, codiEdat = '', alt = '', className = '', directe = false } = props;

    let textEdat = codiEdat?.replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');

    if ((textEdat === 'TP' && directe === false) || textEdat === 'DA') {
        return false;
    }

    const altEdat = !__isEmpty(alt) && !isNaN(textEdat) ? textEdat + ' anys' : alt;

    const hasAD = !__isEmpty(codiAD) ? true : false;

    const hasSub = !__isEmpty(codiSub) && codiSub.length > 0;

    const textSubtitols =
        codiSub && codiSub.length > 0
            ? codiSub
                  .map((item) => item.desc)
                  .join(', ')
                  .replace(/,([^,]*)$/, ' i$1')
            : '';

    const hasVO = codiVO === true;

    const styleCodiEspectador = clsx({
        [styles.codiEspectador]: true,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let src = basePath + '/_resources/icones/codisEspectador/codisEspectador' + textEdat + '.svg?v=JIT_ENV_RESOURCES_VERSION';

    const imageLoader = ({ src }) => {
        return `${src}`;
    };

    //ELIMINAR I DESCOMENTAR CODIS ÈTICS TP
    if ((!__isEmpty(codiEdat) && codiEdat !== 'CE_TP') || hasAD || hasSub || hasVO) {
        //if (!__isEmpty(codiEdat) || hasAD || hasSub || hasVO) {
        return (
            <span className={styleCodiEspectador} data-testid={`codi-espectador-${textEdat}`}>
                {/* //ELIMINAR I DESCOMENTAR CODIS ÈTICS TP */}
                {textEdat && textEdat !== 'TP' && (
                    <Image loader={imageLoader} width={24} height={24} alt={altEdat} src={src} unoptimized={true} />
                )}
                {/* {textEdat && <Image loader={imageLoader} width={24} height={24} alt={altEdat} src={src} unoptimized={true} />} */}
                {hasAD && (
                    <Image
                        loader={imageLoader}
                        width={38}
                        height={24}
                        alt={altEdat}
                        src={
                            basePath +
                            '/_resources/icones/corporatiu/codisEspectador/codisEspectadorAD_solid.svg?v=JIT_ENV_RESOURCES_VERSION'
                        }
                        unoptimized={true}
                    />
                )}
                {hasVO && (
                    <Image
                        loader={imageLoader}
                        width={24}
                        height={24}
                        alt={altEdat}
                        src={
                            basePath +
                            '/_resources/icones/corporatiu/codisEspectador/codisEspectadorVO_solid.svg?v=JIT_ENV_RESOURCES_VERSION'
                        }
                        unoptimized={true}
                    />
                )}
                {hasSub && (
                    <>
                        <Image
                            loader={imageLoader}
                            width={24}
                            height={24}
                            alt={altEdat}
                            src={
                                basePath +
                                '/_resources/icones/corporatiu/codisEspectador/codisEspectadorSubtitols_solid.svg?v=JIT_ENV_RESOURCES_VERSION'
                            }
                            unoptimized={true}
                        />{' '}
                        <span className={styles.subtitols}>{textSubtitols}</span>
                    </>
                )}
            </span>
        );
    } else {
        return false;
    }
}
